module.exports = __webpack_public_path__ + "static/media/proj19_img6.510adf50.jpg";